<template>
	<main class="icon_page">
		<article class="iconInfo">
			<section class="icon_form">
				<div class="icon_wrapper">
					<img src="@/assets/img/mypage/questionMark.png" alt="구독 해지 아이콘" loading="lazy" />
					<div class="icon_title">
						<p>정말 구독을 해지하시겠습니까?</p>
						<p>
							구독 해지 시 {{ date }}에 구독 혜택이<br class="br_show" />
							종료되며 <br class="br_none" />일부메뉴를 열람하실 수 없습니다.
						</p>
					</div>
				</div>
				<div class="c_fieldArea">
					<button
						class="c_button radius-x-small primary-fill save"
						@click="
							$router.replace({
								path: `/sub/details/${route.params.subscription_pk}`,
								query: { currentTab: route.query.currentTab },
							})
						"
					>
						구독 유지하기
					</button>
				</div>
				<div class="icon">
					<button class="c_button" @click="onClickCancel">
						구독 해지하기<img src="@/assets/img/common/arrow_next.svg" alt="구독해지하기 아이콘" loading="lazy" />
					</button>
				</div>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { useRoute, useRouter } from 'vue-router';

// -----variable-----
const route = useRoute();
const router = useRouter();
const date = route.query.date;
// -----function-----
const onClickCancel = async () => {
	router.replace(`/sub/cancel-reason/${route.params.subscription_pk}`);
};
</script>

<style lang="scss" scoped>
.icon_page {
	max-width: 40rem;
	margin: 0 auto;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	@media screen and (max-width: 1280px) {
		padding-left: 2rem;
		padding-right: 2rem;
	}
}
</style>
